import { SearchX, Scale, EyeOff, ClipboardX, BarChart3 } from "lucide-react";

const pains = [
  { icon: SearchX, title: "Lost or mixed-up clothes", text: "Garments go missing or end up with the wrong customer — and you pay for it." },
  { icon: Scale, title: "Customer disputes", text: "\u201cI gave you 12 shirts, not 10!\u201d Arguments with no proof on either side." },
  { icon: EyeOff, title: "No visibility", text: "You can't see what is happening in your shop unless you are standing there." },
  { icon: ClipboardX, title: "Staff errors", text: "Handwritten tickets get lost, misread, or filled in wrong at busy times." },
  { icon: BarChart3, title: "No data", text: "Which service makes the most money? Which customers are leaving? Nobody knows." },
];

export default function Problem() {
  return (
    <section id="problem" data-testid="problem-section" className="bg-[#F8FAFC] py-16 sm:py-24">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <span className="inline-block text-xs font-bold uppercase tracking-widest text-[#1ABC9C] bg-[#E8F8F5] px-4 py-1.5 rounded-full mb-4">The Problem</span>
        <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-[#2C3E50] max-w-2xl">
          Running a laundry on paper and memory is costing you money
        </h2>
        <p className="mt-4 text-lg text-[#5D6D7E] leading-relaxed max-w-2xl">
          Most laundry businesses in Ghana run on notebooks, WhatsApp chats, and guesswork. That creates five expensive problems:
        </p>
        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {pains.map((p, i) => (
            <div key={i} data-testid={`problem-card-${i}`} className="bg-white rounded-2xl border border-[#E2E8F0] p-8 hover:shadow-lg hover:-translate-y-1 transition-all duration-300">
              <span className="w-12 h-12 rounded-xl bg-[#EBF5FB] flex items-center justify-center mb-5">
                <p.icon className="w-6 h-6 text-[#1B4F72]" />
              </span>
              <h3 className="font-display text-lg sm:text-xl font-semibold text-[#2C3E50]">{p.title}</h3>
              <p className="mt-2 text-base text-[#5D6D7E] leading-relaxed">{p.text}</p>
            </div>
          ))}
          <div className="bg-[#1B4F72] rounded-2xl p-8 flex flex-col justify-center">
            <p className="font-display text-xl sm:text-2xl font-bold text-white leading-snug">WashFlow fixes all five — from day one.</p>
            <a href="#solution" data-testid="problem-see-solution-btn" className="mt-4 inline-flex items-center gap-2 text-[#1ABC9C] font-bold">
              See how it works <span aria-hidden="true">&darr;</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
